/* eslint-disable react/no-unknown-property */
/* eslint-disable react/require-default-props */
import React from 'react';

export const DialerVoicemail = ({
  width = 24,
  height = 24,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 10C5.89543 10 5 10.8954 5 12C5 13.1046 5.89543 14 7 14C8.10457 14 9 13.1046 9 12C9 10.8954 8.10457 10 7 10ZM3 12C3 9.79087 4.79086 8 7 8C9.20914 8 11 9.79086 11 12C11 14.2091 9.20914 16 7 16C4.79086 16 3 14.2091 3 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 10C15.8954 10 15 10.8954 15 12C15 13.1046 15.8954 14 17 14C18.1046 14 19 13.1046 19 12C19 10.8954 18.1046 10 17 10ZM13 12C13 9.79086 14.7909 8 17 8C19.2091 8 21 9.79086 21 12C21 14.2091 19.2091 16 17 16C14.7909 16 13 14.2091 13 12Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 15C6 14.4477 6.44772 14 7 14L17 14C17.5523 14 18 14.4477 18 15C18 15.5523 17.5523 16 17 16L7 16C6.44772 16 6 15.5523 6 15Z"
      fill="currentColor"
    />
  </svg>
);
